import {IOption} from "@pg-design/select-module";
import {roomsFormat} from "@pg-mono/string-utils";

import {ALL_ROOMS, RoomsFilter} from "./rcn_rooms_filter";

export const DEFAULT_ROOMS_FILTER: RoomsFilter = ALL_ROOMS;

export const ROOMS_FILTER_OPTIONS: IOption<RoomsFilter>[] = [
    {value: ALL_ROOMS, label: "Wszystkie"},
    ...[1, 2, 3, 4].map((rooms) => ({value: rooms, label: roomsFormat(rooms) ?? `${rooms} pokoje`}))
];
import {IOption} from "@pg-design/select-module";
import {roomsFormat} from "@pg-mono/string-utils";

import {ALL_ROOMS, RoomsFilter} from "./rcn_rooms_filter";

export const DEFAULT_ROOMS_FILTER: RoomsFilter = ALL_ROOMS;

export const ROOMS_FILTER_OPTIONS: IOption<RoomsFilter>[] = [
    {value: ALL_ROOMS, label: "Wszystkie"},
    ...[1, 2, 3, 4].map((rooms) => ({value: rooms, label: roomsFormat(rooms) ?? `${rooms} pokoje`}))
];
